// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3mYRP","left":"InfoRow_left__d9PwV"};